import React from 'react';
import styled from 'styled-components';

export const InputSpacer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;
